export default __webpack_public_path__ + "static/media/icon-do-it-later.d497ea07.svg";